import type { HelpIllustration } from '../diagnosis/types';

export const illustrations = {
  account: {
    src: '/illustrations/account-check.svg',
    alt: '账号页面右上角头像和当前账号位置示意图',
    caption: '看右上角头像对应的账号；示意图中的账号信息已隐藏。',
  },
  region: {
    src: '/illustrations/region-check.svg',
    alt: '搜索页面底部系统识别地区位置示意图',
    caption: '一直滑到搜索页面最底部，以这里显示的地区为准。',
  },
  countryAssociation: {
    src: '/illustrations/country-association-check.svg',
    alt: 'Google 官方条款页账号关联国家或地区位置示意图',
    caption: '网络识别地区与账号关联地区不是同一项，请以官方页面显示为准。',
  },
  countryAssociationFormExample: {
    src: '/illustrations/country-association-form-example.png',
    alt: 'Google 账号地区关联申请表单示例，包含地区选择、关联原因和提交按钮',
    caption: '实际申请页面示例，仅用于帮助识别界面，不代表固定国家或固定勾选项；请以页面提示和账号情况为准，审核结果以 Google 为准。',
  },
  membership: {
    src: '/illustrations/membership-check.svg',
    alt: '会员方案和五 TB 存储权益位置示意图',
    caption: '能看到会员方案或 5TB 存储，才说明权益已经到账。',
  },
  payment: {
    src: '/illustrations/payment-check.svg',
    alt: '付款资料设置页面位置和风险提示示意图',
    caption: '先看国家或地区；不清楚影响时不要删除付款资料。',
  },
  paymentProfileCloseExample: {
    src: '/illustrations/payment-profile-close-example.png',
    alt: 'Google 付款中心设置页面，支付资料状态中的关闭支付资料位置',
    caption: '实际页面示例：仅用于帮助找到“支付资料状态 → 关闭支付资料”；关闭前请先确认没有仍在使用的订阅、余额或付款服务。',
  },
  errors: {
    src: '/illustrations/error-compare.svg',
    alt: '链接打不开和链接已使用两类页面提示对比示意图',
    caption: '请按页面原文选择，不要把 404 和“已使用”当成同一种问题。',
  },
} as const satisfies Record<string, HelpIllustration>;
